import React from 'react';
import { mergeClassNames } from '../../utils/mergeClassNames';
import styles from './FAQ.module.scss';
import ContentBuilder from '../../core/ContentBuilder';

interface FAQProps {
	data:{q:string, a:string}[]
}

export class FAQ extends React.Component<FAQProps>
{
	render()
	{
		return(
			<ul className={styles['faq']}>
				{
					this.props.data.map((item, i) => {
						return (
							<li key={i} className={styles['item']}>
								<div className={mergeClassNames(['q', 'secondary'], styles)}><span className={styles['bullet']}>Q：</span><span>{item['q']}</span></div>
								<div className={mergeClassNames(['a', 'primary'], styles)}>{ContentBuilder.build({content: item['a']}, {}, styles)}</div>
							</li>
						)
					})
				}
			</ul>
		)
	}
}